/*
 * Removes the free $10 gift card line when the cart stops qualifying for it.
 *
 * The 3-bag offer adds the gift card (variant 43561169551419) next to 3 DSS
 * bags; an automatic discount makes it $0 only while 3+ bags are in the cart.
 * snippets/cart-products.liquid marks the gift row with
 * data-mns-gift-paired="true|false" (3+ DSS bags or not).
 *
 * On a cart edit from the drawer or /cart (cart:update with source
 * 'cart-items-component'), this listener runs before Horizon morphs the new
 * HTML in, so the live DOM still shows the old state. If the gift row was
 * paired before and the returned section HTML shows it unpaired, the gift
 * line is removed and the cart sections re-rendered.
 *
 * Page loads and product-form adds are ignored, so a gift card bought on its
 * own is never touched.
 */
(function () {
  if (window.__mnsGiftCleanup) return;
  window.__mnsGiftCleanup = true;

  var SOURCE = 'mns-gift-cleanup';

  function changeUrl() {
    var routes = window.Theme && window.Theme.routes;
    return (routes && routes.cart_change_url) || '/cart/change';
  }

  // Key of the gift line if the new HTML shows it no longer qualifies.
  function orphanedGiftKey(sections) {
    var parser = new DOMParser();
    var ids = Object.keys(sections);
    for (var i = 0; i < ids.length; i++) {
      var html = sections[ids[i]];
      if (!html) continue;
      var doc = parser.parseFromString(html, 'text/html');
      var row = doc.querySelector('[data-mns-gift-line][data-mns-gift-paired="false"]');
      if (row && row.getAttribute('data-key')) return row.getAttribute('data-key');
    }
    return null;
  }

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (ids.indexOf(el.dataset.sectionId) === -1) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function removeGift(key) {
    var body = JSON.stringify({
      id: key,
      quantity: 0,
      sections: sectionIds().join(','),
      sections_url: window.location.pathname
    });

    fetch(changeUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || cart.errors) return;
        // Same event shape as component-cart-items.js, so the drawer, /cart and
        // the header bubble all re-render from the returned sections.
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: SOURCE,
            data: {
              source: SOURCE,
              itemCount: cart.item_count,
              sections: cart.sections
            }
          }
        }));
      })
      .catch(function (err) { console.error(err); });
  }

  document.addEventListener('cart:update', function (event) {
    var data = event.detail && event.detail.data;
    if (!data || data.source !== 'cart-items-component' || !data.sections) return;

    // Old state: the gift row in the not-yet-morphed DOM.
    var wasPaired = document.querySelector('[data-mns-gift-line][data-mns-gift-paired="true"]');
    if (!wasPaired) return;

    var key = orphanedGiftKey(data.sections);
    if (key) removeGift(key);
  });
})();
